import IconClear from './icon_clear.svg';
import s from './index.module.scss';

export const Chip = ({ text, onClear }) => {
  return (
    <div className={s.chip}>
      <span className="f-small-regular">{text}</span>
      <button type="button" className={s.btn_clear} onClick={onClear}>
        <img src={IconClear} alt="clear" width={20} height={20} />
      </button>
    </div>
  );
};
